import { distance } from '../lib/distance-sidecar'
import { IMachine } from '../machines/machines'
import { machines } from '../machines/machines-sidecar'
import { common } from '../main/common-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask, ITaskType, registerTask } from './jobs'
import { jobs } from './jobs-sidecar'

const type: ITaskType = 'fill'
export const register = () => registerTask(type, runTask)

export function createTask_fill(
  i: number,
  j: number,
  action: (t: ITask) => void,
): ITask {
  return jobs._createTask(i, j, type, { action })
}

export function runTask(job: IJob, task: ITask) {
  // TODO: elaborate on fill

  jobLogger.assertTaskType(task, type)
  let m = jobLogger.assertReserved(job)

  if (jobLogger.runSubtasks(job, task)) {
    return
  }

  if (jobLogger.isWaitingForPathOrMovement(job)) {
    return
  }
  let mc = machines.findClosestTo(m.i, m.j, (f) => true)
  if (!mc) {
    return jobLogger.failTask(job, task, 'lost machine')
  }
  if (!distance.isNextToIJ(m, mc)) {
    return jobLogger.failTask(job, task, 'not next to machine')
  }

  // TODO: lock machine to user?

  // increase progress
  task.progress += common.getUpdateDeltaScaled()
  let time = 5
  if (task.progress < time) {
    machines.setProgress(mc, task.progress, time)
    return // Wait
  }
  machines.clearProgress(mc)

  task.action(task)

  return jobLogger.succeedTask(job, task)
}
